import { GlobalObserverState } from "../types/global"

export const getObserverState = (): GlobalObserverState => {
  if (!window.__cirrus_proctorio_observer_singleton__)
    window.__cirrus_proctorio_observer_singleton__ = createInitialState()

  return window.__cirrus_proctorio_observer_singleton__
}

export const observerTakeExamReceived = (): boolean => {
  const state = getObserverState()
  return state.takeExamReceived
}

export const observerSessionStarted = (): boolean => {
  const state = getObserverState()
  return state.sessionStarted
}

export const setObserverSessionStarted = () => {
  const state = getObserverState()
  state.sessionStarted = true
}

export const clearObserverTimers = () => {
  const state = getObserverState()
  state.timers.forEach((timer) => window.clearTimeout(timer))
  state.timers = []
}

const createInitialState = (): GlobalObserverState => ({
  started: false,
  runId: null,
  timers: [],
  takeExamReceived: false,
  sessionStarted: false
})
